<div class="col-lg-8 offset-lg-2 d-flex align-items-center"  style="height: 400px;">
    <div class="mt-6 mb-5 mx-auto" [ngBusy]="busy">
        <div class="text-center">
            <h2 class="mt-2">{{'Succes' | translate}}</h2>
            <p class="succes">{{'OperationSucces' | translate}} <i class="fa fa-check"></i></p>

        </div>
    </div>
</div>